import type { Reader } from 'apiConnector/scheduledRun/model';
import classNames from 'classnames';
import { IcMultiplePicker } from 'components/shared/IcPicker/IcMultiplePicker';
import { SgTagsPicker } from 'components/shared/Tags';
import { useMemo } from 'react';
import { connect } from 'react-redux';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import { getIsUserInternal, getMailingLists } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { MailingList } from 'state/user';

interface StateProps {
  isInternal: boolean;
  readers: readonly Reader[];
  mailingLists: readonly MailingList[];
}
interface DispatchProps {
  onReadersChanged: (readers: readonly Reader[]) => void;
}
interface OwnProps {
  id: string;

  disabled?: boolean;

  readonly?: boolean;
}
interface Props extends StateProps, DispatchProps, OwnProps {}

const mapStateToProps = (appState: AppState, { id }: OwnProps): StateProps => ({
  readers: appState.scheduledRun.runs[id].readers,
  isInternal: getIsUserInternal(appState),
  mailingLists: getMailingLists(appState),
});
const mapDispatchToProps = (dispatch: ThunkDispatch, { id }: OwnProps): DispatchProps => ({
  onReadersChanged(readers) {
    dispatch(scheduledRunActions.readersChanged(id, readers));
  },
});
export const ConnectedReadersPicker = connect(mapStateToProps, mapDispatchToProps)(ReadersPicker);
function ReadersPicker({ mailingLists, readers, isInternal, onReadersChanged, readonly, disabled }: Props) {
  const formattedMailingLists = useMemo(
    () =>
      mailingLists
        .filter(list => list.emails.length > 0)
        .map(list => ({
          key: list.id,
          label: `${list.fullName} - ${list.emails[0]}`,
          email: list.emails[0],
        })),
    [mailingLists],
  );
  return isInternal ? (
    <IcMultiplePicker
      withLabel={false}
      disabled={disabled}
      placeholderTranslationKey="scheduledRun.distributionList.placeholder"
      selectedIds={readers.map(r => r.icId)}
      id="distribution-list"
      onChange={contacts => onReadersChanged(contacts.map(c => ({ email: c.email, icId: c.id })))}
    />
  ) : (
    <SgTagsPicker
      disabled={disabled}
      readonly={readonly}
      singleSelect={false}
      id="distribution-list"
      available={formattedMailingLists}
      className={classNames('overflow-x-auto', { 'overflow-visible': !readonly && !disabled })}
      placeholder="Select additional contact(s)"
      selection={readers.map(r => r.icId)}
      onSelectionItemsChanged={selection => {
        onReadersChanged(selection.map(list => ({ icId: list.key, email: list.email })));
      }}
    />
  );
}
